/**
 * Polyfills for old browsers (usually IE) missing modern JavaScript language
 * features.
 *
 * See also respond.js (polyfill for CSS media queries).
 *
 * @author Chris Barnes http://www.cjbarnes.co.uk
 */

/**
 * Function.prototype.bind
 *
 * @url https://gist.github.com/dsingleton/1312328
 * @author David Singleton https://gist.github.com/dsingleton
 */
Function.prototype.bind=Function.prototype.bind||function(b){if(typeof this!=="function"){throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");}var a=Array.prototype.slice,f=a.call(arguments,1),e=this,c=function(){},d=function(){return e.apply(this instanceof c?this:b||window,f.concat(a.call(arguments)));};c.prototype=this.prototype;d.prototype=new c();return d;};

/**
 * String.prototype.trim
 *
 * @url https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/trim
 */
if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return this.replace(/^[\s\xA0]+|[\s\xA0]+$/g, '');
  };
}


/**
 * Debounce a function
 *
 * @url http://remysharp.com/2010/07/21/throttling-function-calls/
 * @author remy sharp http://remysharp.com
 *
 * @param  function fn    The function to debounce
 * @param  int      delay The minimum gap between function runs
 *
 * @return function The closure
 */
function debounce(fn, delay) {
  var timer = null;
  return function () {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}
